var _path, _polygon, _g, _path2, _path3, _path4, _polygon2, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 788.67004,
    height: 600.83683,
    viewBox: "0 0 788.67004 600.83683",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,544.59645c0,.66003,.53003,1.19,1.19006,1.19H787.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "432.06293 207.9064 440.17624 157.19821 385.41139 134.88661 377.29808 211.96305 432.06293 207.9064",
    fill: "#a0616a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 418.22347,
    cy: 117.65201,
    r: 55.84705,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.76638,42.56955c1.61599,.94332,3.78057-.4839,4.29873-2.2819,.51816-1.79799-.08543-3.70699-.68399-5.47984-1.00441-2.97493-2.00882-5.94987-3.01323-8.9248-2.13705-6.32967-4.40519-12.88052-9.03353-17.69822-6.98573-7.27154-18.08768-9.12139-28.08166-7.78124-12.83424,1.72101-25.49722,8.67062-31.46477,20.1627-5.96755,11.49208-3.42693,27.52765,7.35602,34.69755-15.36808,17.61438-20.72516,37.245-19.8793,60.60585,.84586,23.36084,26.30346,44.86043,42.90521,61.31724,3.70747-2.24742,7.07799-12.77978,5.03922-16.60597-2.03876-3.82618,.88233-8.25893-1.64262-11.78325-2.52495-3.52432-4.63739,2.08745-2.08472-1.41686,1.61078-2.21128-4.67603-7.29848-2.28172-8.62197,11.58089-6.40152,15.43261-20.8366,22.70615-31.89064,8.77325-13.33324,23.78866-22.36263,39.67894-23.86062,8.7534-.82519,17.99892,.66939,25.17375,5.7512,7.17483,5.08181,11.81977,14.16293,10.156,22.79628,4.30889-4.3751,6.45378-10.78682,5.64478-16.87399-.809-6.08717-4.55411-11.7161-9.85617-14.81388,3.22388-10.66119,.46208-22.92467-7.0207-31.17466-7.48278-8.24999-37.83699-6.84486-48.76127-4.67361",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06989,83.33122c-14.46888,1.56191-24.91582,14.09519-33.73739,25.66965-5.08455,6.67125-10.41056,14.03853-10.28292,22.42555,.12905,8.47949,5.79847,15.75251,8.50796,23.78849,4.42876,13.13507,.11241,28.76277-10.43002,37.76282,10.41711,1.97677,21.67828-5.83397,23.47661-16.28336,2.09348-12.16437-7.1277-23.90485-6.03562-36.19965,.96214-10.83186,9.49811-19.16825,16.75495-27.26721,7.25684-8.09896,14.07228-18.84607,10.73376-29.19543",
    fill: "#2f2e41"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.83896,594.83683s-121,12-130-2c-9-14,122.79134-28,122.79134-28l7.20866,30Z",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.68935,370.5l-2.4999,13.27189c6.80859,10.04883,7.46021,20.67285,3.5,31.72803l138,1c-1.48315-14.95264-3.10718-30.96826,2.57471-45.66309l-141.5748-.33683Z",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M563.72626,469.16985l-50.04932-40.03906c-6.6499-5.32031-10.95508-13.23096-11.8125-21.7041l-7.71289-76.27441,45.9458-15.31543,11.07666,75.52344,27.61035,62.75146-15.05811,15.05811Z",
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.18935 203 439.18935 200 510.18935 233.8189 481.18935 372 334.18935 383 314.18935 230 372.18935 203",
    fill: "#01bf71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M479.26416,403.83683c10.06641,13.27002,14.29395,45.22021,18.57471,77,0,0-185.9999-1-186.9999-1-1,0,28.4252-67,28.4252-67l140-9Z",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M485.33896,472.36045l12.5,8.47638s177-12,162,44c-15,56-62,65-62,65l-190,11-2-31s-183,41-200-43c-17-84,105-47,105-47l174.5-7.47638Z",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M410.65392,538.83683s4.18504-22,34.18504-13,47,21,47,21l-72,18-9.18504-26Z",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M485.68935,231.5s34-12,47,27c13,39,10,71,10,71l-50,16-7-114Z",
    fill: "#01bf71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.54364,475.25676l-10.9082-19.21973,23.56738-58.66846,11.07812-75.53174,45.9458,15.31543-7.80615,77.19629c-.79736,7.88721-4.80518,15.25098-10.99512,20.20312l-50.88184,40.70508Z",
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M330.68935,231.5s-34-12-47,27c-13,39-10,71-10,71l50,16,7-114Z",
    fill: "#01bf71"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.18935,
    cy: 442.5,
    rx: 24,
    ry: 35.5,
    fill: "#a0616a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.18935,
    cy: 448.5,
    rx: 24,
    ry: 35.5,
    fill: "#a0616a"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "332.83896 507.83683 419.83896 532.83683 436.83896 562.83683 404.32782 569.83683",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg-3.4ce9f3025206d6c3582a94c54634100d.svg";
export { ForwardRef as ReactComponent };